import React from 'react';
import { useGetJobsiteFormsQuery } from 'apollo/generated/client-operations';
import { JobsiteFormOptionElement } from './types';

export const useJobsiteFormsOptions = (
  formKey: string,
  jobsiteId?: string,
): JobsiteFormOptionElement[] => {
  const { data: jobsiteFormsData } = useGetJobsiteFormsQuery({
    fetchPolicy: 'no-cache',
    skip: !formKey,
    variables: {
      jobsiteFormsInput: { formKey, jobsiteIds: jobsiteId && [jobsiteId] },
    },
  });

  return React.useMemo(() => {
    return (
      jobsiteFormsData?.getCurrentSession.user.jobsiteForms.edges.map<JobsiteFormOptionElement>(
        ({ node: { id, jobsite } }) => ({
          value: id,
          label: jobsite.name,
          jobsiteId: jobsite.jobsiteId,
          timeZone: jobsite.timeZone,
        }),
      ) ?? []
    );
  }, [jobsiteFormsData]);
};

export {
  type JobsiteContractorForOption,
  getJobsiteContractorsOptions,
  useJobsiteContractorsOptions,
} from 'containers/utils';
